import React from 'react';

const STEPS = [
  {
    n: 1,
    title: 'Aceptación del artículo',
    text: 'La solicitud de financiación se pedirá una vez que la revista haya aceptado nuestro artículo para su publicación.',
  },
  {
    n: 2,
    title: 'Correo electrónico del editor',
    text: <>Cuando la revista haya aceptado nuestro artículo, el editor nos enviará un correo con un enlace para iniciar el <em>author journey</em>.</>,
  },
  {
    n: 3,
    title: 'Filiación Universidad de Oviedo',
    text: 'Dentro de la plataforma de gestión del autor o la autora, lo más importante es elegir como filiación la Universidad de Oviedo; de lo contrario el editor no podrá enviar la solicitud de financiación para aplicar el acuerdo transformativo.',
  },
  {
    n: 4,
    title: 'Publish Open Access',
    text: 'De todas las opciones para publicar, elegiremos la opción de publicarlo en acceso abierto.',
  },
  {
    n: 5,
    title: 'Licencia Creative Commons',
    text: 'Al elegir la opción anterior tendremos que seleccionar una licencia creative commons para proteger nuestros derechos de propiedad intelectual. Hay dos opciones: que podamos definir los usos permitidos según nuestras preferencias o que estemos obligados a seleccionar la única que permita el editor.',
  },
  {
    n: 6,
    title: 'Aprobación BUO',
    text: 'Cuando el autor o la autora elija como filiación la Universidad de Oviedo y la opción de acceso abierto, el editor comprobará si existe acuerdo transformativo con su institución y, si lo hay, enviará a la Universidad la solicitud de financiación. La Biblioteca Universitaria es la que se encarga de aprobar las solicitudes.',
  },
  {
    n: 7,
    title: 'Notificación automática',
    text: <>Una vez que la BUO aprueba una solicitud a través de los diferentes <em>dashboards</em> de los editores, estos envían un correo electrónico automático al autor o a la autora informando de que su institución ha aprobado la solicitud.</>,
  },
];

const WorkflowComponent = () => {
  return (
    <div>
      {/* Header */}
      <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: '#1a1a1a',
          letterSpacing: -0.3, lineHeight: 1.3,
          fontFamily: "'Inter','Segoe UI',sans-serif",
          padding: '0 24px',
        }}>
          Procedimiento de solicitud
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 16 }}>
          Pasos a seguir para publicar en acceso abierto mediante un acuerdo transformativo
        </div>
      </div>

      <div style={{ padding: '32px 48px 48px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '20px',
        }}>
          {STEPS.map((step) => (
            <div key={step.n} style={{
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #007398',
              padding: '20px 24px 20px 20px',
              position: 'relative',
              overflow: 'hidden',
            }}>
              {/* Watermark number */}
              <div style={{
                position: 'absolute', top: -6, right: 14,
                fontSize: 80, fontWeight: 900, color: '#007398', opacity: 0.06,
                lineHeight: 1, pointerEvents: 'none', userSelect: 'none',
              }}>
                {String(step.n).padStart(2, '0')}
              </div>
              {/* Badge */}
              <div style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 28, height: 28, borderRadius: '50%',
                background: '#007398', color: '#fff',
                fontSize: 13, fontWeight: 700, marginBottom: 10,
              }}>
                {step.n}
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 8 }}>
                {step.title}
              </div>
              <div style={{ fontSize: 13.5, color: '#555', lineHeight: 1.75 }}>
                {step.text}
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div style={{
          marginTop: 24, padding: '16px 20px',
          background: '#f6fbfc', borderRadius: 8, borderLeft: '3px solid #007398',
          fontSize: 13.5, color: '#555', lineHeight: 1.75,
        }}>
          Recibida dicha notificación el autor o la autora ya no tiene que hacer nada más, salvo que estemos ante un descuento del total de los APCs, en cuyo caso recibirá una factura ya con el descuento aplicado que tendrá que pagar con fondos propios.{' '}
          Consulta en detalle el procedimiento o <em>workflow</em> de cada editor en la guía de la{' '}
          <a
            href="https://biblioguias.unav.edu/acuerdos-transformativos/procedimiento-investigadores-un"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#007398' }}
          >
            Universidad de Navarra
          </a>.
        </div>
      </div>
    </div>
  );
};

export default WorkflowComponent;
